const initCopyElement = () => {
    //copy html
    $("[copy-html-from]").each(function(){
        let targetElm = $(this).attr("copy-html-from")
        let html = $(targetElm).html()
        $(this).html(html)
    })
    $("[copy-image-from]").each(function(){
        let targetElm = $(this).attr("copy-image-from")
        let img = $(targetElm).find("img").attr("src")
        if($(this).hasClass("lazy")) {
            $(targetElm).find("img").attr("src", "")
            $(targetElm).find("img").attr("data-src", img)
        }

        if($(this).find('img').length) {
            $(this).find('img').attr("src", img);
        }
        else {
            $(this).css({
                backgroundImage: `url('${img}')`
            })
        }
    })
}

module.exports = initCopyElement
